import { pxToRem } from 'utils/convert';

export const GRID = `
minmax(${pxToRem(485)}, 1fr)
${pxToRem(125)} 
${pxToRem(137)} 
${pxToRem(122)} 
${pxToRem(122)} 
`;

export const CA_STORAGE_KEY = 'CA-snippets';
export const MI_STORAGE_KEY = 'MI-snippets';
